// Country codes with dial codes and flags - Most common countries only
export const countryCodes = [
    { dialCode: '+1', name: 'US', display: '+1 (US/CA)', flag: '🇺🇸' },
    { dialCode: '+44', name: 'GB', display: '+44 (UK)', flag: '🇬🇧' },
    { dialCode: '+91', name: 'IN', display: '+91 (IN)', flag: '🇮🇳' },
    { dialCode: '+86', name: 'CN', display: '+86 (CN)', flag: '🇨🇳' },
    { dialCode: '+81', name: 'JP', display: '+81 (JP)', flag: '🇯🇵' },
    { dialCode: '+49', name: 'DE', display: '+49 (DE)', flag: '🇩🇪' },
    { dialCode: '+33', name: 'FR', display: '+33 (FR)', flag: '🇫🇷' },
    { dialCode: '+39', name: 'IT', display: '+39 (IT)', flag: '🇮🇹' },
    { dialCode: '+34', name: 'ES', display: '+34 (ES)', flag: '🇪🇸' },
    { dialCode: '+61', name: 'AU', display: '+61 (AU)', flag: '🇦🇺' },
    { dialCode: '+55', name: 'BR', display: '+55 (BR)', flag: '🇧🇷' },
    { dialCode: '+7', name: 'RU', display: '+7 (RU)', flag: '🇷🇺' },
    { dialCode: '+82', name: 'KR', display: '+82 (KR)', flag: '🇰🇷' },
    { dialCode: '+52', name: 'MX', display: '+52 (MX)', flag: '🇲🇽' },
    { dialCode: '+31', name: 'NL', display: '+31 (NL)', flag: '🇳🇱' },
    { dialCode: '+46', name: 'SE', display: '+46 (SE)', flag: '🇸🇪' },
    { dialCode: '+41', name: 'CH', display: '+41 (CH)', flag: '🇨🇭' },
    { dialCode: '+32', name: 'BE', display: '+32 (BE)', flag: '🇧🇪' },
    { dialCode: '+47', name: 'NO', display: '+47 (NO)', flag: '🇳🇴' },
    { dialCode: '+45', name: 'DK', display: '+45 (DK)', flag: '🇩🇰' },
    { dialCode: '+358', name: 'FI', display: '+358 (FI)', flag: '🇫🇮' },
    { dialCode: '+48', name: 'PL', display: '+48 (PL)', flag: '🇵🇱' },
    { dialCode: '+351', name: 'PT', display: '+351 (PT)', flag: '🇵🇹' },
    { dialCode: '+353', name: 'IE', display: '+353 (IE)', flag: '🇮🇪' },
    { dialCode: '+64', name: 'NZ', display: '+64 (NZ)', flag: '🇳🇿' },
    { dialCode: '+27', name: 'ZA', display: '+27 (ZA)', flag: '🇿🇦' },
    { dialCode: '+971', name: 'AE', display: '+971 (AE)', flag: '🇦🇪' },
    { dialCode: '+966', name: 'SA', display: '+966 (SA)', flag: '🇸🇦' },
    { dialCode: '+65', name: 'SG', display: '+65 (SG)', flag: '🇸🇬' },
    { dialCode: '+852', name: 'HK', display: '+852 (HK)', flag: '🇭🇰' },
    { dialCode: '+60', name: 'MY', display: '+60 (MY)', flag: '🇲🇾' },
    { dialCode: '+62', name: 'ID', display: '+62 (ID)', flag: '🇮🇩' },
    { dialCode: '+66', name: 'TH', display: '+66 (TH)', flag: '🇹🇭' },
    { dialCode: '+84', name: 'VN', display: '+84 (VN)', flag: '🇻🇳' },
    { dialCode: '+63', name: 'PH', display: '+63 (PH)', flag: '🇵🇭' },
    { dialCode: '+92', name: 'PK', display: '+92 (PK)', flag: '🇵🇰' },
    { dialCode: '+880', name: 'BD', display: '+880 (BD)', flag: '🇧🇩' },
    { dialCode: '+20', name: 'EG', display: '+20 (EG)', flag: '🇪🇬' },
    { dialCode: '+234', name: 'NG', display: '+234 (NG)', flag: '🇳🇬' },
    { dialCode: '+254', name: 'KE', display: '+254 (KE)', flag: '🇰🇪' },
    { dialCode: '+972', name: 'IL', display: '+972 (IL)', flag: '🇮🇱' },
    { dialCode: '+90', name: 'TR', display: '+90 (TR)', flag: '🇹🇷' },
    { dialCode: '+380', name: 'UA', display: '+380 (UA)', flag: '🇺🇦' },
];

